import axios from 'axios';
import SearchResultInterface from '@/interfaces/SearchResultInterface';
import { env } from '@/helpers';

class SearchAPI {
  static search(term: string): Promise<SearchResultInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<SearchResultInterface[]>(`${env('API_BASE_PATH')}search`, {
        params: {
          term,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default SearchAPI;
